module.exports = __webpack_public_path__ + "img/content-img-1.228da091.jpg";